import { apiV2 } from '../../../api/ApiV2';

export const pay = (orders: number[]) => {
  apiV2.order
    .payOrders({
      ids: orders
    })
    .then(resp => (window.location.href = resp.item.url));
};
